import { MenuItem } from '@wordpress/components';
import { media as mediaIcon } from '@wordpress/icons';
import { DEFAULT_ICON_WIDTH } from '@constants';

const {
  i18n: { __ },
  blockEditor: { MediaUpload },
} = wp;

const sanitizeRawSVGString = (rawString) => {
  const svgDoc = new window.DOMParser().parseFromString(
    rawString,
    'image/svg+xml',
  );
  let svgString = '';
  svgString = new window.XMLSerializer().serializeToString(
    svgDoc.documentElement,
  );

  return svgString;
};

const MediaInserter = ({ setAttributes, onClose }) => (
  <MediaUpload
    onSelect={(media) => {
      if (media.subtype === 'svg+xml') {
        fetch(media.url)
          .then((response) => response.text())
          .then((svgString) => {
            setAttributes({
              icon: sanitizeRawSVGString(svgString),
              iconExtension: media.subtype,
              iconName: '',
              attachmentId: media.id,
              width: DEFAULT_ICON_WIDTH,
              enableWidth: true,
            });
          })
          .catch((e) => {
            // eslint-disable-next-line no-console
            console.error(e);
          });
      } else {
        setAttributes({
          iconName: media.url,
          iconExtension: media.subtype,
          icon: '',
          attachmentId: media.id,
          width: DEFAULT_ICON_WIDTH,
          enableWidth: true,
        });
      }

      onClose();
    }}
    allowedTypes={['image']}
    render={({ open }) => (
      <MenuItem
        onClick={() => {
          open();
        }}
        icon={mediaIcon}
      >
        {__('Open Media Library', 'b3rg')}
      </MenuItem>
    )}
  />
);

export default MediaInserter;
